export default "__VITE_ASSET__Dxuju8ie__"